import React from "react";
import propTypes from "prop-types";
import { createTheme, ThemeProvider } from "@mui/material/styles";

const theme = createTheme({
  components: {
    MuiTextField: {
      defaultProps: {
        size: "small",
      },
    },
  },
});

export function AdvanceTheme({ children }) {
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}

AdvanceTheme.propTypes = {
  children: propTypes.node,
};
